'use strict';

angular.module('app.home.lazypost', ['wu.masonry', 'infinite-scroll']);